module.exports = __webpack_public_path__ + "static/img/obverse.6914131a.png";